module.exports = __webpack_public_path__ + "static/ball-map-c2f6a0e07905906652bd9131edf9ae64.jpg";